import React from 'react';
import { useLocation } from "react-router-dom";
import {  Link } from 'react-router-dom'
import './MedicalHistoryNav.css';
import { PATIENT_MEDICAL_HISTORY_PAGES } from './medicalHistoryPages';
import moment from 'moment';

var UserData;
export default function MedicalHistoryNav() {
  debugger
  UserData = JSON.parse(localStorage.getItem("UData"));
  let Clinic =  localStorage.getItem("ClinicName");
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  let MainGender = localStorage.getItem("PatientGender");
  return (
        <>
          <div className='card-header mb-2'>
            <div className="row">
              <div className="col">
                <h5>Medical History</h5>
              </div>
              <div className="col text-right">
                ( {UserData?.firstName} {UserData?.lastName} , {moment(UserData?.birthday).format("DD-MMM-YYYY")} ({UserData?.age}) ,{UserData?.gendercodeName} )
              </div>
            </div>
          </div>
          <section class="ftco-section">
            <ul class="nav nav-tabs">

              { Clinic != "Hull" ?
              <li className={splitLocation[1] === "MedicalHistory" ? "active nav-item" : ""}>
                <Link to='/MedicalHistory' className='nav-link nav-link-Medical'>Patient Medical History</Link>
              </li>
                : null}

            {/* { Clinic === "Hull" ?

            <li className={splitLocation[1] === "MedicalHistory" ? "active nav-item" : ""}>
                            <Link to='/Medical_History' className='nav-link nav-link-Medical'>Patient Medical History</Link>
                          </li>
              : null
              } */}


               {Clinic === "Hull" ? (
                (MainGender === 1 || MainGender === "1") ? (
                  // Medical_History male
                  <li className={splitLocation[1] === "MedicalHistory" ? "active nav-item" : ""}>
                                          <Link to='/MedicalSocialHistory2' className='nav-link nav-link-Medical'>Patient Medical History</Link>
                                        </li>
                ) : (
                  // Medical_History Female
              <li className={splitLocation[1] === "MedicalHistory" ? "active nav-item" : ""}>
                                          <Link to='/MedicalSocialHistory' className='nav-link nav-link-Medical'>Patient Medical History</Link>
                                        </li>
                )
              ) : null}
    
              {/* <li className={splitLocation[1] === "TreatMentWithUs" ? "active nav-item" : ""}>
                <Link to='/TreatMentWithUs' className='nav-link nav-link-Medical' >Treatment with Us</Link>
              </li> */}

              <li className={splitLocation[1] === "PreviousFertilityTreatment" ? "active nav-item" : ""}>
                <Link to='/PreviousFertilityTreatment' className='nav-link nav-link-Medical' >Previous Fertility Treatment</Link>
              </li>
              <li className={splitLocation[1] === "PreviousPregnancy" ? "active nav-item" : ""}>
                <Link to='/PreviousPregnancy' className='nav-link nav-link-Medical' > Previous Pregnancy</Link>
              </li>
              <li className={splitLocation[1] === "Allergies" ? "active nav-item" : ""}>
                <Link to='/Allergies' className='nav-link nav-link-Medical' >Allergies</Link>
              </li>
              <li className={splitLocation[1] === "PreviousProcedure" ? "active nav-item" : ""}>
                <Link to='/PreviousProcedure' className='nav-link nav-link-Medical' >Previous Procedure</Link>
              </li>
              <li className={splitLocation[1] === "Prescription" ? "active nav-item" : ""}>
                <Link to='/Prescription' className='nav-link nav-link-Medical' >Prescription</Link>
              </li>
              <li className={splitLocation[1] === "DrugReminder" ? "active nav-item" : ""}>
                <Link to='/DrugReminder' className='nav-link nav-link-Medical' >Drug Reminder</Link>
              </li>


            </ul>
          </section>
        </>
  )
}